const u = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?q=80&w=${w}&auto=format&fit=crop`;

export const SERVICES_DETAIL = [
  {
    slug: "ristrutturazioni-complete",
    variant: "wide",
    title: "Ristrutturazioni complete",
    claim: "dal primo muro all'ultima finitura.",
    intro:
      "Un appartamento, una villa o un'abitazione da trasformare: seguiamo l'intera ristrutturazione coordinando ogni lavorazione, con una regia unica e un programma di lavori chiaro fin dal primo giorno.",
    heroImg: u("1616486338812-3dadae4b4ace", 2200),
    heroAlt: "Soggiorno di appartamento completamente ristrutturato",
    includes: [
      "Coordinamento di tutte le fasi del cantiere",
      "Demolizioni e opere murarie",
      "Predisposizioni per i nuovi impianti",
      "Pavimenti, rivestimenti e cartongessi",
      "Tinteggiature e finiture finali",
      "Consegna dell'immobile pulito e finito",
    ],
    steps: [
      { t: "Sopralluogo e analisi", d: "Vediamo l'immobile, ascoltiamo le tue esigenze e raccogliamo misure e informazioni." },
      { t: "Programma dei lavori", d: "Definiamo le fasi, la sequenza delle lavorazioni e un preventivo chiaro." },
      { t: "Cantiere coordinato", d: "Ogni lavorazione è seguita direttamente e tu sei sempre aggiornato." },
      { t: "Finiture e consegna", d: "Curiamo i dettagli finali e consegniamo l'immobile verificandolo insieme a te." },
    ],
    gallery: [
      { src: u("1615873968403-89e068629265"), alt: "Interno ristrutturato con cucina a vista" },
      { src: u("1600573472592-401b489a3cdc"), alt: "Camera da letto dopo la ristrutturazione completa" },
    ],
    benefits: [
      { t: "Un solo interlocutore", d: "Idraulici, elettricisti e imbianchini li coordiniamo noi: tu hai un solo numero da chiamare." },
      { t: "Tempi organizzati", d: "Le lavorazioni seguono un programma condiviso, senza fermi inutili del cantiere." },
      { t: "Nessuna sorpresa", d: "Ogni lavorazione è descritta nel preventivo prima dell'inizio dei lavori." },
    ],
    ctaLabel: "Vuoi ristrutturare casa senza pensieri?",
    seoTitle: "Ristrutturazioni Complete — SOPAJ Impresa Edile | Appartamenti e Ville",
    seoDescription:
      "Ristrutturazioni complete di appartamenti, ville e abitazioni: demolizioni, murature, impianti, pavimenti e finiture coordinati da una sola regia, fino alla consegna delle chiavi.",
  },
  {
    slug: "opere-murarie",
    variant: "split",
    title: "Opere murarie",
    claim: "la struttura giusta per ogni ambiente.",
    intro:
      "Demolizioni, nuovi tramezzi, aperture e modifiche interne: le opere murarie sono la base di ogni ristrutturazione fatta bene. Le eseguiamo con cura, proteggendo gli ambienti e lasciando il cantiere in ordine.",
    heroImg: u("1504917595217-d4dc5ebe6122", 2200),
    heroAlt: "Lavorazioni murarie in cantiere",
    includes: [
      "Demolizioni controllate e smaltimento dei materiali",
      "Costruzione di tramezzi, muretti e spallette",
      "Aperture e modifiche sulle murature",
      "Ripristini, rasature e preparazione delle superfici",
      "Opere murarie di preparazione alle altre lavorazioni",
    ],
    steps: [
      { t: "Valutazione tecnica", d: "Verifichiamo le strutture e la fattibilità dell'intervento prima di iniziare." },
      { t: "Protezione degli ambienti", d: "Copriamo pavimenti, porte e arredi prima di aprire il cantiere." },
      { t: "Esecuzione", d: "Demoliamo, costruiamo e modifichiamo secondo il programma concordato." },
      { t: "Ripristino", d: "Rasiamo e prepariamo le superfici per le lavorazioni successive." },
    ],
    gallery: [
      { src: u("1531834685032-c34bf0d84c77"), alt: "Operaio al lavoro su opere murarie" },
      { src: u("1513467535987-fd81bc7d62f8"), alt: "Dettaglio di muratura in mattoni" },
    ],
    benefits: [
      { t: "Lavorazioni a regola d'arte", d: "La muratura è la base di tutto: la eseguiamo con la cura che merita." },
      { t: "Cantiere protetto", d: "Ambienti e superfici esistenti vengono protetti prima di ogni lavorazione." },
      { t: "Ordine e pulizia", d: "Smaltiamo i materiali e manteniamo il cantiere vivibile durante i lavori." },
    ],
    ctaLabel: "Hai muri da demolire o ambienti da ridisegnare?",
    seoTitle: "Opere Murarie — SOPAJ Impresa Edile | Demolizioni, Tramezzi e Aperture",
    seoDescription:
      "Opere murarie per ristrutturazioni: demolizioni controllate, costruzione di tramezzi, aperture e modifiche interne, ripristini e rasature. Sopralluogo e preventivo chiaro.",
  },
  {
    slug: "rifacimento-bagni",
    variant: "editorial",
    title: "Rifacimento bagni",
    claim: "dal vecchio impianto al bagno finito.",
    intro:
      "Ristrutturiamo il bagno da cima a fondo: demolizione, predisposizioni idrauliche, massetto, rivestimenti, sanitari e finiture. Una sola squadra, un bagno consegnato pronto all'uso.",
    heroImg: u("1552321554-5fefe8c9ef14", 2200),
    heroAlt: "Bagno contemporaneo appena ristrutturato con doccia",
    includes: [
      "Demolizione e rimozione di sanitari e vecchi rivestimenti",
      "Nuove tracce e predisposizioni idrauliche",
      "Massetto e preparazione dei fondi",
      "Posa di pavimenti e rivestimenti",
      "Installazione di doccia, sanitari e accessori",
      "Tinteggiatura e finiture finali",
    ],
    steps: [
      { t: "Sopralluogo e misure", d: "Rileviamo lo stato esistente e definiamo la nuova distribuzione." },
      { t: "Demolizione", d: "Rimuoviamo sanitari, rivestimenti e pavimento esistente." },
      { t: "Predisposizioni e fondi", d: "Realizziamo tracce, scarichi e massetto." },
      { t: "Posa e finiture", d: "Posiamo rivestimenti, sanitari e completiamo ogni dettaglio." },
    ],
    gallery: [
      { src: u("1584622650111-993a426fbf0a"), alt: "Bagno moderno con rivestimenti chiari" },
      { src: u("1507652313519-d4e9174996dd"), alt: "Dettaglio di bagno ristrutturato con lavabo" },
    ],
    benefits: [
      { t: "Tempi contenuti", d: "Il rifacimento del bagno segue un programma preciso per ridurre il disagio." },
      { t: "Nessun telefono da rincorrere", d: "Muratura, predisposizioni e finiture seguite dalla stessa squadra." },
      { t: "Pronto all'uso", d: "Ti consegniamo il bagno finito, pulito e funzionante." },
    ],
    ctaLabel: "Vuoi rifare il bagno?",
    seoTitle: "Rifacimento Bagni — SOPAJ Impresa Edile | Ristrutturazione Completa del Bagno",
    seoDescription:
      "Rifacimento completo del bagno: demolizione, predisposizioni idrauliche, massetto, posa rivestimenti, sanitari e finiture. Un unico referente fino alla consegna.",
  },
  {
    slug: "rifacimento-cucine",
    variant: "split",
    title: "Rifacimento cucine",
    claim: "la base perfetta per la tua nuova cucina.",
    intro:
      "Prima che arrivi la nuova cucina serve un cantiere preciso: demolizioni, spostamento degli attacchi, nuove predisposizioni, pavimenti e rivestimenti. Prepariamo tutto noi, in coordinamento con il montatore.",
    heroImg: u("1556912167-f556f1f39fdf", 2200),
    heroAlt: "Cucina moderna appena completata dopo la ristrutturazione",
    includes: [
      "Demolizione e rimozione della vecchia cucina",
      "Spostamento di attacchi idraulici ed elettrici",
      "Nuove tracce e predisposizioni",
      "Pavimento e rivestimento della zona cottura",
      "Preparazione delle pareti per il montaggio",
      "Ripristini e finiture dopo l'installazione",
    ],
    steps: [
      { t: "Analisi del progetto", d: "Partiamo dal progetto della nuova cucina per posizionare ogni predisposizione." },
      { t: "Demolizione", d: "Rimuoviamo la vecchia cucina e prepariamo l'ambiente." },
      { t: "Predisposizioni", d: "Spostiamo attacchi e scarichi dove serve al nuovo progetto." },
      { t: "Fondi e finiture", d: "Posiamo pavimento e rivestimenti e completiamo le pareti." },
    ],
    gallery: [
      { src: u("1556911220-bff31c812dba"), alt: "Cucina finita con piano di lavoro in legno" },
      { src: u("1600585152220-90363fe7e115"), alt: "Cucina contemporanea con isola dopo i lavori" },
    ],
    benefits: [
      { t: "Coordinamento con il montatore", d: "Parliamo direttamente con chi monterà la cucina: zero incomprensioni." },
      { t: "Attacchi nel punto giusto", d: "Le predisposizioni seguono il progetto, non il contrario." },
      { t: "Ambiente pronto al montaggio", d: "Consegniamo una cucina pronta ad accogliere i nuovi arredi." },
    ],
    ctaLabel: "Stai per cambiare la cucina?",
    seoTitle: "Rifacimento Cucine — SOPAJ Impresa Edile | Opere Murarie e Predisposizioni",
    seoDescription:
      "Rifacimento della cucina: demolizioni, spostamento attacchi, predisposizioni impiantistiche, pavimenti e rivestimenti. Cantiere coordinato con il montatore della nuova cucina.",
  },
  {
    slug: "pavimenti-rivestimenti",
    variant: "wide",
    title: "Pavimenti e rivestimenti",
    claim: "superfici precise, posa curata.",
    intro:
      "Gres, grandi lastre, parquet, SPC e rivestimenti a parete: prepariamo i fondi come si deve e posiamo ogni superficie con precisione, dalle fughe regolari ai battiscopa.",
    heroImg: u("1502005229762-cf1b2da7c5d6", 2200),
    heroAlt: "Pavimento in legno posato in un soggiorno ristrutturato",
    includes: [
      "Rimozione dei vecchi pavimenti",
      "Massetti e autolivellanti per fondi regolari",
      "Posa di gres porcellanato e grandi lastre",
      "Posa di parquet e pavimenti SPC",
      "Rivestimenti a parete per bagni e cucine",
      "Battiscopa, soglie e rifiniture",
    ],
    steps: [
      { t: "Verifica del fondo", d: "Controlliamo planarità e stato del supporto prima di posare." },
      { t: "Schema di posa", d: "Definiamo insieme disegno, verso delle fughe e tagli nascosti." },
      { t: "Posa", d: "Utilizziamo collanti e materiali adatti a ogni superficie." },
      { t: "Stuccatura e pulizia", d: "Fughe stuccate, superfici pulite e controllate alla consegna." },
    ],
    gallery: [
      { src: u("1581858726788-75bc0f6a952d"), alt: "Posa di pavimento durante la ristrutturazione" },
      { src: u("1493663284031-b7e3aefcae8e"), alt: "Ambiente con pavimento in legno completato" },
    ],
    benefits: [
      { t: "Fondi preparati bene", d: "Un pavimento dura anni solo se il fondo è fatto correttamente." },
      { t: "Posa precisa", d: "Fughe regolari, tagli puliti e attenzione ai punti visibili." },
      { t: "Consiglio sui materiali", d: "Ti aiutiamo a scegliere la superficie giusta per ogni ambiente." },
    ],
    ctaLabel: "Vuoi cambiare pavimenti?",
    seoTitle: "Pavimenti e Rivestimenti — SOPAJ Impresa Edile | Posa Gres, Parquet e SPC",
    seoDescription:
      "Preparazione dei fondi e posa di pavimenti e rivestimenti: gres porcellanato, grandi lastre, parquet, SPC, battiscopa e rifiniture. Posa precisa e materiali adatti.",
  },
  {
    slug: "cartongesso-controsoffitti",
    variant: "editorial",
    title: "Cartongesso e controsoffitti",
    claim: "ridisegnare gli ambienti senza muratura.",
    intro:
      "Controsoffitti con luce integrata, velette, pareti divisorie e cabine armadio: con il cartongesso trasformiamo gli spazi in modo pulito e veloce, nascondendo impianti e creando nuove geometrie.",
    heroImg: u("1621905251189-08b45d6a269e", 2200),
    heroAlt: "Tecnico al lavoro su una struttura in cartongesso",
    includes: [
      "Controsoffitti con illuminazione integrata",
      "Velette e ribassamenti per tende e luci",
      "Pareti divisorie in cartongesso",
      "Cabine armadio, nicchie e librerie",
      "Chiusura di impianti e colonne",
      "Rasatura e preparazione alla tinteggiatura",
    ],
    steps: [
      { t: "Disegno delle forme", d: "Definiamo quote, forme e punti luce prima di partire." },
      { t: "Struttura", d: "Montiamo l'orditura metallica e fissiamo le lastre." },
      { t: "Integrazione luci", d: "Predisponiamo faretti, strisce led e corpi illuminanti." },
      { t: "Rasatura e finitura", d: "Stucchiamo giunti e viti per una superficie pronta al colore." },
    ],
    gallery: [
      { src: u("1618220179428-22790b461013"), alt: "Camera con controsoffitto e illuminazione integrata" },
      { src: u("1513694203232-719a280e022f"), alt: "Soggiorno con controsoffitto e faretti" },
    ],
    benefits: [
      { t: "Cantieri puliti", d: "Il cartongesso lavora a secco: meno polvere, tempi rapidi." },
      { t: "Luce su misura", d: "Integriamo l'illuminazione direttamente nelle nuove forme." },
      { t: "Spazi ridisegnati", d: "Nuove pareti e volumi senza opere murarie invasive." },
    ],
    ctaLabel: "Vuoi ridisegnare un ambiente?",
    seoTitle: "Cartongesso e Controsoffitti — SOPAJ Impresa Edile | Velette e Illuminazione Integrata",
    seoDescription:
      "Lavori in cartongesso: controsoffitti con illuminazione integrata, velette, pareti divisorie, cabine armadio e nicchie. Cantieri puliti e finiture pronte alla tinteggiatura.",
  },
  {
    slug: "tinteggiature-finiture",
    variant: "split",
    title: "Tinteggiature e finiture",
    claim: "l'ultimo passo, quello che si nota.",
    intro:
      "Pareti lisce, colori scelti con calma, dettagli curati: le finiture sono ciò che vedi ogni giorno quando il cantiere è finito. Le eseguiamo con la stessa attenzione delle opere murarie.",
    heroImg: u("1562259949-e8e7689d7828", 2200),
    heroAlt: "Ambiente interno con pareti tinteggiate e finiture curate",
    includes: [
      "Preparazione, stuccatura e rasatura delle pareti",
      "Tinteggiature interne ed esterne",
      "Pitture decorative e finiture particolari",
      "Ripristino di crepe e imperfezioni",
      "Verniciatura di elementi in legno e ferro",
      "Finiture finali di fine cantiere",
    ],
    steps: [
      { t: "Preparazione", d: "Stucchiamo, rasiamo e carteggiamo: il colore sta bene solo su pareti sane." },
      { t: "Campionature", d: "Proviamo i colori a parete prima della tinteggiatura completa." },
      { t: "Tinteggiatura", d: "Applichiamo le pitture scelte con protezione di pavimenti e arredi." },
      { t: "Controllo finale", d: "Rivediamo ogni parete in controluce prima della consegna." },
    ],
    gallery: [
      { src: u("1615874959474-d609969a20ed"), alt: "Camera con pareti colorate e finiture complete" },
      { src: u("1616594039964-ae9021a400a0"), alt: "Soggiorno con tinteggiatura chiara completato" },
    ],
    benefits: [
      { t: "Pareti uniformi", d: "Rasature accurate e pitture di qualità per superfici lisce e omogenee." },
      { t: "Colori senza ripensamenti", d: "Le campionature a parete evitano sorprese a lavoro finito." },
      { t: "Casa protetta", d: "Copriamo e proteggiamo tutto ciò che non va tinteggiato." },
    ],
    ctaLabel: "Vuoi rinnovare le pareti di casa?",
    seoTitle: "Tinteggiature e Finiture — SOPAJ Impresa Edile | Pitture e Finiture di Cantiere",
    seoDescription:
      "Tinteggiature interne ed esterne, rasature, pitture decorative e finiture di fine cantiere. Preparazione accurata delle pareti e colori scelti con campionature.",
  },
  {
    slug: "esterni",
    variant: "wide",
    title: "Esterni",
    claim: "facciate, balconi e terrazzi come nuovi.",
    intro:
      "Interveniamo sulle parti esterne dell'edificio: facciate, balconi, terrazzi, ingressi e cortili. Lavorazioni organizzate con attenzione alla sicurezza e al rispetto del vicinato.",
    heroImg: u("1600047509807-ba8f99d2cdde", 2200),
    heroAlt: "Facciata esterna di abitazione ristrutturata",
    includes: [
      "Ripristino e tinteggiatura delle facciate",
      "Interventi su balconi e terrazzi",
      "Impermeabilizzazione di superfici esterne",
      "Piccole opere murarie esterne",
      "Sistemazione di ingressi, cortili e vialetti",
      "Ripristino di cornici, soglie e davanzali",
    ],
    steps: [
      { t: "Sopralluogo esterno", d: "Valutiamo lo stato di facciate, balconi e superfici." },
      { t: "Organizzazione", d: "Pianifichiamo ponteggi o piattaforme dove necessario." },
      { t: "Lavorazioni", d: "Ripristini, impermeabilizzazioni e tinteggiature esterne." },
      { t: "Verifica finale", d: "Controlliamo ogni superficie e liberiamo le aree esterne." },
    ],
    gallery: [
      { src: u("1568605114967-8130f3a36994"), alt: "Esterno di villa con giardino curato" },
      { src: u("1523217582562-09d0def993a6"), alt: "Facciata chiara di abitazione dopo il ripristino" },
    ],
    benefits: [
      { t: "Edificio protetto", d: "Ripristini e impermeabilizzazioni difendono la casa dagli agenti esterni." },
      { t: "Lavori organizzati", d: "Ponteggi e lavorazioni pianificate per ridurre tempi e disagi." },
      { t: "Aspetto curato", d: "Una facciata rinnovata cambia completamente l'aspetto della casa." },
    ],
    ctaLabel: "Facciata o balcone da sistemare?",
    seoTitle: "Lavori Esterni — SOPAJ Impresa Edile | Facciate, Balconi e Terrazzi",
    seoDescription:
      "Interventi sulle parti esterne: ripristino e tinteggiatura facciate, balconi, terrazzi, impermeabilizzazioni e piccole opere murarie esterne.",
  },
  {
    slug: "manutenzioni-edili",
    variant: "editorial",
    title: "Manutenzioni edili",
    claim: "piccoli interventi, fatti bene.",
    intro:
      "Non serve una grande ristrutturazione per tenere la casa in ordine: ripristini, ritocchi, piccole opere murarie e sistemazioni. Interveniamo in modo rapido, con costi chiari fin da subito.",
    heroImg: u("1621905252507-b35492cc74b4", 2200),
    heroAlt: "Tecnico durante un intervento di manutenzione edile",
    includes: [
      "Ripristini murari e ritocchi di tinteggiatura",
      "Sistemazioni di pavimenti e rivestimenti",
      "Manutenzione di balconi e parti esterne",
      "Piccole riparazioni in casa",
      "Interventi ordinari e straordinari",
      "Manutenzioni programmate nel tempo",
    ],
    steps: [
      { t: "Sopralluogo rapido", d: "Vediamo il problema e ti diciamo subito come lo risolviamo." },
      { t: "Preventivo chiaro", d: "Costo e tempi definiti prima dell'intervento." },
      { t: "Intervento", d: "Eseguiamo la manutenzione in modo pulito e veloce." },
      { t: "Verifica", d: "Controlliamo il risultato insieme prima di chiudere il lavoro." },
    ],
    gallery: [
      { src: u("1621905251918-48416bd8575a"), alt: "Tecnico al lavoro con trapano durante una manutenzione" },
      { src: u("1530124566582-a618bc2615dc"), alt: "Utensili da lavoro per manutenzioni edili" },
    ],
    benefits: [
      { t: "Interventi rapidi", d: "Le piccole manutenzioni vengono pianificate senza attese inutili." },
      { t: "Una sola impresa da chiamare", d: "Per ogni manutenzione della casa, piccola o grande che sia." },
      { t: "Costi trasparenti", d: "Sai quanto spendi prima che iniziamo." },
    ],
    ctaLabel: "Hai una manutenzione da fare?",
    seoTitle: "Manutenzioni Edili — SOPAJ Impresa Edile | Ripristini e Piccole Opere",
    seoDescription:
      "Manutenzioni edili ordinarie e straordinarie: ripristini murari, ritocchi, sistemazioni di pavimenti e parti esterne. Interventi rapidi con costi chiari.",
  },
];
